import PolicyDetailHeader from './PolicyDetailHeader'

export default PolicyDetailHeader
